var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
export var VTM4 = function (_a) {
    var className = _a.className;
    return (React.createElement(Logo, { src: "/images/logos/vtm-4-color-2024.svg", className: className, alt: "VTM 4 logo" }));
};
export var Logo = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    width: auto;\n    height: 1.5rem;\n"], ["\n    position: relative;\n    width: auto;\n    height: 1.5rem;\n"])));
var templateObject_1;
